import api from "apis/inspectorTimeCard";
import { InspectorTimeCardResponse } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "tools/webservice";

export const getInspectorListSummary = (payPeriodId: number, operationsManagerInternetUserId: number, operationsDirectorInternetUserId: number, fieldDevelopmentManagerInternetUserId: number, isTrainee: boolean, roles: number[], successCallback: (list: InspectorTimeCardResponse[]) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/inspectors/time-card/pay-period/${payPeriodId}/summary`,
  payload: { 
    payPeriodId,
    employeeRoleList: roles,
    operationsManagerInternetUserId,
    operationsDirectorInternetUserId,
    fieldDevelopmentManagerInternetUserId,
    isTrainee,
  },
  successCallback,
  mountedRef,
});

export const getInspectorManagers = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorManagers(),
  successCallback,
  mountedRef,
});

export const getInspectorDailySummary = (inspectorNumber, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorDailySummary(inspectorNumber, payPeriodId),
  successCallback,
  mountedRef,
});

export const getInspectorCaseTime = (inspectorNumber, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorCaseTime(inspectorNumber, payPeriodId),
  successCallback,
  mountedRef,
});

export const setInspectorCaseTime = (timeUpdates, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.updateInspectorCaseTime(),
  payload: timeUpdates.map(s => ({ ControlIdNumber: s.controlNumber, DriveTimeMinutes: s.driveTime, SiteTimeMinutes: s.siteTime, WebTimeMinutes: s.webTime })),
  successCallback,
  mountedRef,
});

export const getInspectorCaseMiles = (inspectorNumber, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.inspectorCaseMiles(inspectorNumber, payPeriodId),
  successCallback,
  mountedRef,
});

export const setInspectorCaseMiles = (mileUpdates, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.updateInspectorCaseMiles(),
  payload: mileUpdates.map(s => ({ ControlIdNumber: s.controlNumber, MileageActual: s.milesActual })),
  successCallback,
  mountedRef,
});
